/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteCustomFieldDropdownOptionInput = {
    customFieldDefinitionId: string;
    optionId: string;
    replacementOptionId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeleteCustomFieldDropdownOptionMutationVariables = {
    input: DeleteCustomFieldDropdownOptionInput;
};
export type DeleteCustomFieldDropdownOptionMutationResponse = {
    readonly deleteCustomFieldDropdownOption: {
        readonly clientMutationId: string | null;
        readonly deletedOptionId: string | null;
        readonly replacementOptionId: string | null;
    } | null;
};
export type DeleteCustomFieldDropdownOptionMutation = {
    readonly response: DeleteCustomFieldDropdownOptionMutationResponse;
    readonly variables: DeleteCustomFieldDropdownOptionMutationVariables;
};



/*
mutation DeleteCustomFieldDropdownOptionMutation(
  $input: DeleteCustomFieldDropdownOptionInput!
) {
  deleteCustomFieldDropdownOption(input: $input) {
    clientMutationId
    deletedOptionId
    replacementOptionId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCustomFieldDropdownOptionInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomFieldDropdownOptionPayload",
    "kind": "LinkedField",
    "name": "deleteCustomFieldDropdownOption",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedOptionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replacementOptionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCustomFieldDropdownOptionMutation(\n  $input: DeleteCustomFieldDropdownOptionInput!\n) {\n  deleteCustomFieldDropdownOption(input: $input) {\n    clientMutationId\n    deletedOptionId\n    replacementOptionId\n  }\n}\n"
  }
};
})();
(node as any).hash = '5cbe68ef9b23e3c300fc146b606c22a2';
export default node;
